module.exports = __webpack_public_path__ + "img/CB0010_bear_stroke.280d3625.png";